import React, { Component } from "react";
import styled from "styled-components";

import { useTheme } from "../../hooks/";
import { StyledText } from "../common/basic";

const LiveStreamCard = ({
  backgroundImage,
  title,
  location,
  onClick,
  date,
}) => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  return (
    <Wrapper onClick={() => onClick()}>
      <Image src={backgroundImage} />
      <Gradient>
        <Body>
          <StyledText style={{ marginBlockEnd: 0 }} size={18} color={"white"}>
            {title}
          </StyledText>
          <StyledText size={8} color={"white"}>
            {location}
          </StyledText>
          <StyledText size={10} color={"white"}>
            {date}
          </StyledText>
        </Body>
      </Gradient>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 250px;
  height: 250px;
  border-radius: 20px;
  margin: 0 10px 15px 20px;
  position: relative;
  box-shadow: 0 5px 4px rgba(0, 0, 0, 0.3); 
`;
const Image = styled.img`
  width: 250px;
  height: 250px;
  position: absolute;
  border-radius: 20px;
`;
const Gradient = styled.div`
  width: 250px;
  height: 250px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: relative;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-end;
`;
const Tag = styled.div`
  background-color: ${(prop) => prop.color};
  width: min-content;
  padding: 1px;
  margin-block-start: 0;
  margin-block-end: 0;
`;

const Body = styled.div`
  padding: 10px;
`;

const Arrow = styled.div`
  width: 30px;
  height: 30px;
  background-color: ${(prop) => prop.color};
  border-radius: 15px;
  margin: 15px;
  justify-content: center;
  align-content: center;
  display: grid;
`;

LiveStreamCard.defaultProps = {
  title: "Springboard Roadshow",
  location: "online ",
};

export default LiveStreamCard;
